import { Fragment } from 'react';

// ** MUI
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';

// ** Components

// ** Theme Config
import type { Settings } from '../../../../context/settingsContext';

// ** Types
import type { NavSectionTitle } from '../../../../types';

// ** Utils

interface Props {
  item: NavSectionTitle;
  settings: Settings;
  hasParent: boolean;
}

const HorizontalNavSectionTitle = (props: Props) => {
  // ** Props
  const { item, settings, hasParent } = props;

  const Wrapper = !hasParent ? List : Fragment;

  return (
    <Wrapper
      {...(!hasParent
        ? {
            component: 'div',
            sx: { py: settings.skin === 'bordered' ? 2.625 : 2.75 },
          }
        : {})}
    >
      <ListSubheader component="div">{item.sectionTitle}</ListSubheader>
    </Wrapper>
  );
};

export default HorizontalNavSectionTitle;
